import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import deepmerge from 'deepmerge';
import { INFO_BLOCK_TYPE } from "./blocks/infoCards/constants";
export var getContentData = function getContentData(state) {
  return state.content;
};
export var getSharedData = function getSharedData(state) {
  return state.shared || emptyObj;
};
export var getModulesData = function getModulesData(state) {
  return state.modules || emptyObj;
};
export var getAddressCheckModuleData = function getAddressCheckModuleData(state) {
  return getModulesData(state).addressCheck;
};
export var getCheckAddressModuleData = function getCheckAddressModuleData(state) {
  return getModulesData(state).checkAddress;
};
export var getInfoCardsModuleData = function getInfoCardsModuleData(state) {
  return getModulesData(state).infoCards;
};
export var getPaymentMethods = function getPaymentMethods(state) {
  return getSharedData(state).paymentMethods;
};
var getIsInfoModalOpen = function getIsInfoModalOpen(state) {
  return getInfoCardsModuleData(state).isOpen;
};
var getIsInfoModalType = function getIsInfoModalType(state) {
  return getInfoCardsModuleData(state).type;
};
export var getCurrentBannerCard = function getCurrentBannerCard(state) {
  return getInfoCardsModuleData(state).current;
};
export var getIsSupportModalOpen = function getIsSupportModalOpen(state) {
  return getIsInfoModalOpen(state) && getIsInfoModalType(state) === INFO_BLOCK_TYPE.support;
};
export var getIsPaymentModalOpen = function getIsPaymentModalOpen(state) {
  return getIsInfoModalOpen(state) && getIsInfoModalType(state) === INFO_BLOCK_TYPE.topUp;
};
export var getDevicesModuleData = function getDevicesModuleData(state) {
  return getModulesData(state).devices;
};
export var getFloatingPhoneWidget = function getFloatingPhoneWidget(state) {
  return getModulesData(state).floatingPhone;
};
export var getIsFloatingPhoneWidgetOpen = function getIsFloatingPhoneWidgetOpen(state) {
  return getFloatingPhoneWidget(state).isOpen;
};
var getActionBarModulesData = function getActionBarModulesData(state) {
  return getModulesData(state).actionBarWithBackCall;
};
export var getIsActionBarOpen = function getIsActionBarOpen(state) {
  return getActionBarModulesData(state).isOpen;
};
export var getIsOnTariffClick = function getIsOnTariffClick(state) {
  return getActionBarModulesData(state).isOnTariffClick;
};

/**
 * Композер корневого селектора блоков, позволяет переопределять любые контентные поля со стороны BackEnd'а
 *   подходит под структуру динамических блоков ШПД
 */
export var createMergedBlockSelector = function createMergedBlockSelector(getBlockRoot) {
  return createSelector([function (state) {
    var _getBlockRoot;
    return ((_getBlockRoot = getBlockRoot(state)) === null || _getBlockRoot === void 0 ? void 0 : _getBlockRoot.content) || emptyObj;
  }, function (state) {
    var _getBlockRoot2;
    return ((_getBlockRoot2 = getBlockRoot(state)) === null || _getBlockRoot2 === void 0 ? void 0 : _getBlockRoot2.data) || emptyObj;
  }], function (content, data) {
    return deepmerge(content, data, {
      arrayMerge: function arrayMerge(_, incoming) {
        return incoming;
      }
    });
  });
};